import * as yup from 'yup';

export const AverageCostSchema = yup.object().shape({
  newAverageCost: yup.number(),
});
